import React from "react";
import { Navigate } from "react-router-dom";

import { useAuth } from "../../contexts/AuthContext";
import LoadingOverlay from "../ui/LoadingOverlay";

const PublicRoute = ({ children }) => {
  const { loading, user } = useAuth();

  if (loading) {
    return <LoadingOverlay />;
  }

  if (user) {
    return (
      <Navigate to={user.two_fa_enabled ? "/" : "/setup-2fa"} replace />
    );
  }

  return children;
};

export default PublicRoute;
